import $ from 'jquery';

$(() => {
  const storiesCount = $('#storiesList').data('load-more');
  const storiesCurrentIndex = $('#storiesList').data('initial-count');

  $('.js-load-more').on('click', function (e) {
    $(this).parent().addClass('loadinng-progress');
    e.preventDefault();
  });
  $('.load-more-stories').on('click', function (e) {
    const parent = $(this).parent();
    const _self = $(this);// eslint-disable-line no-underscore-dangle
    _self.hide();
    parent.addClass('loadinng-progress');
    $.get(`/umbraco/Surface/Stories/LoadMore?count= ${storiesCount} &startIndex= ${storiesCurrentIndex}`, (data) => {
      $('#storiesList').append(data.HTMLString);
      if (data.NoMoreData) {
        _self.css('display', 'none');
      } else {
        _self.css('display', 'inline-block');
      }
    }).done(() => {
      currentIndex += count;// eslint-disable-line no-undef
      parent.removeClass('loadinng-progress');
    });
    e.preventDefault();
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/load-more.js
 **/